export default "__VITE_ASSET__3PbWWN8s__"